(function () {
  'use strict';

  if (!document.getElementById('eoo-variant-filter-styles')) {
    const style = document.createElement('style');
    style.id = 'eoo-variant-filter-styles';
    style.textContent = '.variant-color-hidden { display: none !important; }';
    document.head.appendChild(style);
  }

  /**
   * Build sorted color breakpoints from variant data.
   * Each color's start position is the minimum featured_media.position
   * among all variants of that color.
   *
   * Example result (sorted by startPos):
   *   [ { color: 'negro', startPos: 1 },
   *     { color: 'blanco', startPos: 4 },
   *     { color: 'azul',   startPos: 7 } ]
   *
   * Filtering rule for a selected color:
   *   show image if  startPos[color] <= image.position < startPos[nextColor]
   *   (images before the first color breakpoint are always shown)
   */
  function buildBreakpoints(variants) {
    const map = new Map(); // color -> minimum featuredMediaPosition
    variants.forEach(({ color, featuredMediaPosition }) => {
      if (!color || !featuredMediaPosition) return;
      const c = color.toLowerCase().trim();
      if (!map.has(c) || featuredMediaPosition < map.get(c)) {
        map.set(c, featuredMediaPosition);
      }
    });
    return Array.from(map.entries())
      .map(([color, startPos]) => ({ color, startPos }))
      .sort((a, b) => a.startPos - b.startPos);
  }

  function getRange(color, breakpoints) {
    const idx = breakpoints.findIndex((b) => b.color === color);
    if (idx === -1) return null;
    return {
      start: breakpoints[idx].startPos,
      end: idx < breakpoints.length - 1 ? breakpoints[idx + 1].startPos - 1 : Infinity,
    };
  }

  function applyFilter(gallery, color, breakpoints) {
    const range = color ? getRange(color, breakpoints) : null;
    const firstBreak = breakpoints.length > 0 ? breakpoints[0].startPos : 1;

    function visible(pos) {
      if (!pos || !range) return true;          // no position data or no color selected
      if (pos < firstBreak) return true;         // general images before any color group
      return pos >= range.start && pos <= range.end;
    }

    // Viewer items
    const viewerUl = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (viewerUl) {
      viewerUl.querySelectorAll('li[data-media-id]').forEach((li) => {
        li.classList.toggle('variant-color-hidden', !visible(parseInt(li.dataset.position || '0', 10)));
      });
    }

    // Thumbnail items
    const thumbUl = gallery.querySelector('[id^="Slider-Thumbnails-"]');
    if (thumbUl) {
      thumbUl.querySelectorAll('li[data-target]').forEach((li) => {
        li.classList.toggle('variant-color-hidden', !visible(parseInt(li.dataset.position || '0', 10)));
      });
    }
  }

  function getInitialColor(sectionId, colorOptionIndex) {
    const scope =
      document.querySelector(`product-info[data-section="${sectionId}"]`) ||
      document.querySelector(`#MainProduct-${sectionId}`);
    if (!scope) return '';
    const el = scope.querySelector('[data-selected-variant]');
    if (!el) return '';
    try {
      const variant = JSON.parse(el.textContent || el.innerHTML || '{}');
      return ((variant?.options || [])[colorOptionIndex] || '').toLowerCase().trim();
    } catch {
      return '';
    }
  }

  function init(sectionId) {
    const dataEl = document.getElementById(`VariantColorData-${sectionId}`);
    if (!dataEl) return;

    let config;
    try { config = JSON.parse(dataEl.textContent); } catch { return; }

    const { colorOptionIndex, variants } = config;
    if (!variants || colorOptionIndex < 0) return;

    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (!gallery) return;

    const breakpoints = buildBreakpoints(variants);
    if (breakpoints.length === 0) return;

    // Filter on page load
    applyFilter(gallery, getInitialColor(sectionId, colorOptionIndex), breakpoints);

    // Re-filter on every variant change.
    // PUB_SUB_EVENTS.variantChange fires after Dawn's updateMedia() + setActiveMedia() finish.
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;
      const color = ((data.variant?.options || [])[colorOptionIndex] || '').toLowerCase().trim();
      requestAnimationFrame(() => applyFilter(gallery, color, breakpoints));
    });
  }

  // Script is deferred — DOM is fully parsed at this point
  document.querySelectorAll('[id^="VariantColorData-"]').forEach((el) => {
    init(el.id.replace('VariantColorData-', ''));
  });
})();
